import { useState, createContext, useContext } from 'react';
import Api from '../../services/api/api';

const authContext = createContext();

function useAuth() {
    const [user, setUser] = useState(null);

    return {
        user,
        login() {
            return Api.getCurrentUser().then((user) => {
                if (user) {
                    setUser(user);
                }
            });
        },
        logout() {
            return new Promise((resolve) => {
                setUser(null);
                resolve();
            });
        }
    };
}

export function AuthProvider({ children }) {
    const auth = useAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export default function AuthConsumer() {
    return useContext(authContext);
}